import { environment } from 'environments/environment';
import { runtimeEnv } from 'app/core/types/runtime-env';

/**
 * Public marketing site (Terms/Privacy live there — `projects/photoflow`
 * `/terms`, `/privacy`). Resolution mirrors iam-portal's `marketingSiteUrl()`:
 *  1. runtime `MARKETING_SITE_URL` on the pod, if infra sets one;
 *  2. derive from `environment.iamPortalUrl`: the tier label sits in front of
 *     `-iam.`/`iam.` (`dev-iam.photoflow.vn` → `dev.photoflow.vn`,
 *     `iam.photoflow.vn` → `photoflow.vn`, `iam.localhost` → landing dev port);
 *  3. `''` — an unset link renders as the current page instead of a wrong host.
 */
export function marketingSiteUrl(): string {
    const runtime = runtimeEnv().marketingSiteUrl;
    if (runtime) return runtime.replace(/\/$/, '');

    try {
        const url = new URL(environment.iamPortalUrl);
        const host = url.hostname;
        const tiered = host.match(/^(.*)-iam\.(.+)$/);
        if (tiered) return `${url.protocol}//${tiered[1]}.${tiered[2]}`;
        if (host.startsWith('iam.')) return `${url.protocol}//${host.slice(4)}`;
        if (host === 'iam.localhost' || host === 'localhost')
            return 'http://localhost:3002'; // tooling `PORT_LANDING`
        return '';
    } catch {
        return '';
    }
}
